import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

const vuetify = new Vuetify({
	theme: {
		breakpoint: {
			thresholds: {
				xs: 767,
				sm: 960,
				md: 1260,
				lg: 1800,
			},
			scrollBarWidth: 5,
		},
		options: {
			customProperties: true,
		},
		themes: {
			light: {
				primary: "#c2262f",
				secondary: "#ff3823",
				accent: "#1264f6",
				error: "#ff3823",
				info: "#2196F3",
				success: "#6b9953",
				warning: "#ff6624",
				default: "#bbbbbb",
				orange: "#ffc372",
			},
		},
	},
});

export default vuetify;
